module.exports = __webpack_public_path__ + "assets/img/webmoney.35a362e3.svg";